import { useRef, useState, useEffect } from 'react'
import { webSocketWorkerEvent } from '../../../services'
import { MODAL_TYPE } from '../../../utils/constants'

const useDealMessageHandler = () => {
  const [data, setData] = useState({})
  const timeoutRef = useRef(null)
  useEffect(() => {
    // Set a timeout on mount
    timeoutRef.current = setTimeout(() => {
      if (Object.keys(data).length === 0) {
        window.close()
      }
    }, 2000)

    // Clean up if component unmounts
    return () => clearTimeout(timeoutRef.current)
  }, [])

  useEffect(() => {
    const handelWindowMessage = event => {
      if (event.origin !== window.origin) {
        window.close()
      }
      if (event.data?.type === MODAL_TYPE.DEAL) {
        setData(event.data)
        clearTimeout(timeoutRef.current)
      }
    }
    window.addEventListener('message', handelWindowMessage)
    return () => window.removeEventListener('message', handelWindowMessage)
  }, [])

  useEffect(() => {
    const handelMessage = message => {
      if (message.data.type === 'log-out-system') {
        window.close()
      }
    }
    webSocketWorkerEvent.addEventListener('message', handelMessage)
    return () => webSocketWorkerEvent.removeEventListener('message', handelMessage)
  }, [])

  return { data }
}

export default useDealMessageHandler
